// import React, { useCallback, useEffect, useState } from 'react';
// import {
// 	TextField,
// 	Button,
// 	Grid,
// 	Typography,
// 	Box,
// 	IconButton,
// 	MenuItem,
// 	FormControl,
// 	InputLabel,
// 	Select,
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import CloseIcon from '@mui/icons-material/Close';
// import { getAllEvent, GetAllMenuTypes } from '../../../services/api/Event';
// import MenuSection from './MenuSection';
// import { MennuTypeQuotation } from '../../../services/api/quotation';

// interface MenuItemType {
// 	menuType: string;
// 	numberOfPersons: number;
// 	items: string[];
// }

// interface FormData {
// 	_id: string;
// 	name: string;
// 	description: string;
// 	status: number;
// 	complementary: { item: string; quantity: number }[];
// 	price: number;
// 	menuTypes: MenuItemType[];
// 	menuImage?: Array<{ file?: File; preview: string; url?: string }>;
// 	slug?: string;
// 	eventType: string;
// }

// interface MenuFormProps {
// 	menu?: any;
// 	onSubmit: (data: FormData) => void | Promise<void>;
// 	availableMenuTypes?: string[];
// }

// const MenuForm: React.FC<MenuFormProps> = ({
// 	menu,
// 	onSubmit,
// 	availableMenuTypes = ['Lunch', 'Dinner', 'Breakfast'],
// }) => {
// 	const [menuTypes, setMenuTypes] = useState<string[]>([]);
// 	const [eventTypes, setEventTypes] = useState<{ _id: string; eventType: string }[]>([]);
// 	const [selectedQuotation, setSelectedQuotation] = useState<any>();

// 	const [formData, setFormData] = useState<FormData>({
// 		_id: menu?._id || '',
// 		name: menu?.name || '',
// 		description: menu?.description || '',
// 		status: menu?.status || 0,
// 		complementary: menu?.complementary || [{ item: '', quantity: 1 }],
// 		price: menu?.price || 0,
// 		eventType: menu?.eventType?._id || '',
// 		menuTypes: menu?.menuItems?.length
// 			? menu.menuItems.map((item: any) => ({
// 				menuType: item?.menuType || '',
// 				numberOfPersons: item.numberOfPersons || 1,
// 				menuItems: { Items: Array.isArray(item.items) ? item.items : [] },
// 			}))
// 			: [],
// 		menuImage: menu?.menuImage?.map((img: string) => ({ url: img })) || [],
// 		slug: menu?.slug || '',
// 	});

// 	const fetchAllCategories = async () => {
// 		try {
// 			const response = await MennuTypeQuotation(selectedQuotation);
// 			if (response.success) {
// 				setMenuTypes(response?.data?.menuTypeNames || []);
// 			}
// 		} catch (err) {
// 			console.error('Error fetching categories:', err);
// 			setMenuTypes([]);
// 		}
// 	};

// 	useEffect(() => {
// 		if (selectedQuotation) {
// 			fetchAllCategories();
// 		}
// 	}, [selectedQuotation]);

// 	useEffect(() => {
// 		return () => {
// 			formData.menuImage?.forEach((image) => {
// 				if (image.preview) URL.revokeObjectURL(image.preview);
// 			});
// 		};
// 	}, []);

// 	const generateSlug = (name: string) =>
// 		name
// 			.toLowerCase()
// 			.replace(/\s+/g, '-')
// 			.replace(/[^\w-]+/g, '')
// 			.replace(/--+/g, '-')
// 			.replace(/^-/, '')
// 			.replace(/-$/, '');

// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
// 		const { name, value } = e.target;
// 		setFormData((prev) => ({
// 			...prev,
// 			[name]: name === 'price' ? parseFloat(value) || 0 : value,
// 		}));
// 	};

// 	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const { name, value } = e.target;
// 		setFormData((prev) => ({
// 			...prev,
// 			[name]: value,
// 			slug: generateSlug(value),
// 		}));
// 	};

// 	const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const files = e.target.files;
// 		if (files) {
// 			const newImages = Array.from(files).map((file) => ({
// 				file,
// 				preview: URL.createObjectURL(file),
// 			}));
// 			setFormData((prev) => ({
// 				...prev,
// 				menuImage: [...(prev.menuImage || []), ...newImages],
// 			}));
// 		}
// 	};

// 	const handleRemoveImage = (index: number) => {
// 		const updatedImages = [...(formData.menuImage || [])];
// 		if (updatedImages[index].preview) {
// 			URL.revokeObjectURL(updatedImages[index].preview);
// 		}
// 		updatedImages.splice(index, 1);
// 		setFormData((prev) => ({ ...prev, menuImage: updatedImages }));
// 	};

// 	const handleSubmit = (e: React.FormEvent) => {
// 		e.preventDefault();
// 		if (!validateForm()) {
// 			console.error('Form validation failed');
// 			return;
// 		}
// 		onSubmit(formData);
// 	};

// 	const validateForm = (): boolean =>
// 		!!formData.name &&
// 		formData.price >= 0 &&
// 		formData.menuTypes.length > 0 &&
// 		formData.menuTypes.every(
// 			(item) => !!item.menuType && item.items.length > 0 && item.numberOfPersons >= 1
// 		) &&
// 		formData.complementary.every((item) => !!item.item && item.quantity >= 1);

// 	const handleAddMenuItem = () => {
// 		setFormData((prev) => ({
// 			...prev,
// 			menuTypes: [
// 				...prev.menuTypes,
// 				{
// 					menuType: menuTypes[0] || availableMenuTypes[0],
// 					numberOfPersons: 1,
// 					menuItems: { items: [] },
// 				},
// 			],
// 		}));
// 	};

// 	const handleMenuItemChange = (index: number, updatedItem: MenuItemType) => {
// 		const updated = [...formData.menuTypes];
// 		updated[index] = updatedItem;
// 		setFormData((prev) => ({ ...prev, menuTypes: updated }));
// 	};

// 	const handleRemoveMenuItem = (index: number) => {
// 		const updated = [...formData.menuTypes];
// 		updated.splice(index, 1);
// 		setFormData((prev) => ({ ...prev, menuItems: updated }));
// 	};

// 	const handleComplementaryItemChange = (
// 		index: number,
// 		field: 'item' | 'quantity',
// 		value: string | number
// 	) => {
// 		const updatedItems = [...formData.complementary];
// 		updatedItems[index][field] = value as never;
// 		setFormData((prev) => ({ ...prev, complementary: updatedItems }));
// 	};

// 	const handleAddComplementaryItem = () => {
// 		setFormData((prev) => ({
// 			...prev,
// 			complementary: [...prev.complementary, { item: '', quantity: 1 }],
// 		}));
// 	};

// 	const handleRemoveComplementaryItem = (index: number) => {
// 		const updatedItems = [...formData.complementary];
// 		updatedItems.splice(index, 1);
// 		setFormData((prev) => ({ ...prev, complementary: updatedItems }));
// 	};

// 	const loadEventTypes = useCallback(async () => {
// 		try {
// 			const response = await getAllEvent();
// 			setEventTypes(response.data.eventTypes);
// 		} catch (error) {
// 			console.error('Failed to load event types:', error);
// 		}
// 	}, []);

// 	useEffect(() => {
// 		loadEventTypes();
// 	}, [loadEventTypes]);

// 	return (
// 		<Box component="div" sx={{ padding: 2 }}>
// 			<Typography variant="subtitle1" gutterBottom sx={{ marginBottom: 3 }}>
// 				{menu ? 'Update the menu details' : 'Fill in the details to add a new Menu'}
// 			</Typography>
// 			<form onSubmit={handleSubmit} id="menu-form">
// 				<Grid container spacing={3}>
// 					<Grid item xs={12} sm={6}>
// 						<Typography variant="subtitle2" gutterBottom>
// 							Menu Name *
// 						</Typography>
// 						<TextField
// 							fullWidth
// 							size="small"
// 							placeholder="e.g., Budget buffet menu"
// 							name="name"
// 							value={formData.name}
// 							onChange={handleNameChange}
// 							required
// 							sx={{ backgroundColor: 'white' }}
// 						/>
// 					</Grid>
// 					<Grid item xs={12} sm={6}>
// 						<Typography variant="subtitle2" gutterBottom>
// 							Slug *
// 						</Typography>
// 						<TextField
// 							fullWidth
// 							size="small"
// 							placeholder="e.g., budget-buffet-menu"
// 							name="slug"
// 							value={formData.slug}
// 							onChange={handleChange}
// 							required
// 							sx={{ backgroundColor: 'white' }}
// 						/>
// 					</Grid>
// 					<Grid item xs={12} sm={6}>
// 						<Typography variant="subtitle2" gutterBottom>
// 							Price *
// 						</Typography>
// 						<TextField
// 							fullWidth
// 							size="small"
// 							placeholder="e.g., 399000"
// 							name="price"
// 							type="number"
// 							value={formData.price}
// 							onChange={handleChange}
// 							inputProps={{ step: '0.01' }}
// 							required
// 							sx={{ backgroundColor: 'white' }}
// 						/>
// 					</Grid>
// 					<Grid item xs={12} sm={6}>
// 						<Typography variant="subtitle2" gutterBottom>
// 							Event Type *
// 						</Typography>
// 						<FormControl size="small" fullWidth>
// 							<InputLabel>Event Type</InputLabel>
// 							<Select
// 								value={formData.eventType}
// 								onChange={(e) => {
// 									setFormData({
// 										...formData,
// 										eventType: e.target.value,
// 									});
// 									setSelectedQuotation(e.target.value);
// 								}}
// 								label="Event Type"
// 								required
// 							>
// 								{eventTypes.map((type) => (
// 									<MenuItem key={type._id} value={type._id}>
// 										{type.eventType}
// 									</MenuItem>
// 								))}
// 							</Select>
// 						</FormControl>
// 					</Grid>

// 					<Grid item xs={12}>
// 						<Box mb={4}>
// 							<Typography
// 								variant="subtitle1"
// 								color="primary"
// 								gutterBottom
// 								sx={{ fontWeight: 'bold' }}
// 							>
// 								Menu Items *
// 							</Typography>

// 							{formData.menuTypes.map((menuItem, index) => (
// 								<MenuSection
// 									key={index}
// 									menuItem={menuItem}
// 									onChange={(updatedItem) => handleMenuItemChange(index, updatedItem)}
// 									onRemove={() => handleRemoveMenuItem(index)}
// 									availableMenuTypes={menuTypes.length ? menuTypes : availableMenuTypes}
// 								/>
// 							))}
// 							<Button
// 								variant="outlined"
// 								startIcon={<AddIcon />}
// 								onClick={handleAddMenuItem}
// 								sx={{
// 									mt: 2,
// 									'&:hover': {
// 										backgroundColor: 'primary.main',
// 										color: 'white',
// 									},
// 								}}
// 							>
// 								Add Another Menu Type
// 							</Button>
// 						</Box>
// 					</Grid>
// 					<Grid item xs={12}>
// 						<Box mb={4} mt={2}>
// 							<Typography
// 								variant="subtitle1"
// 								color="primary"
// 								gutterBottom
// 								sx={{ fontWeight: 'bold' }}
// 							>
// 								Complementary Items
// 							</Typography>
// 							{formData.complementary.map((item, index) => (
// 								<Box key={index} display="flex" alignItems="center" gap={2} mb={2}>
// 									<TextField
// 										label="Item Name"
// 										value={item.item}
// 										onChange={(e) =>
// 											handleComplementaryItemChange(index, 'item', e.target.value)
// 										}
// 										size="small"
// 										fullWidth
// 									/>
// 									<TextField
// 										label="Quantity"
// 										type="number"
// 										value={item.quantity}
// 										onChange={(e) =>
// 											handleComplementaryItemChange(index, 'quantity', parseInt(e.target.value))
// 										}
// 										size="small"
// 									/>
// 									{formData.complementary.length > 1 && (
// 										<IconButton onClick={() => handleRemoveComplementaryItem(index)}>
// 											<CloseIcon />
// 										</IconButton>
// 									)}
// 								</Box>
// 							))}
// 							<Button
// 								variant="outlined"
// 								startIcon={<AddIcon />}
// 								onClick={handleAddComplementaryItem}
// 							>
// 								Add Complementary Item
// 							</Button>
// 						</Box>
// 					</Grid>
// 					<Grid item xs={12}>
// 						<Box mb={4}>
// 							<Typography
// 								variant="subtitle1"
// 								color="primary"
// 								gutterBottom
// 								sx={{ fontWeight: 'bold' }}
// 							>
// 								Menu Images
// 							</Typography>
// 							<Typography variant="caption">Maximum 10 Images</Typography> <br />
// 							<Box display="flex" flexWrap="wrap" gap={1} mt={2}>
// 								{formData.menuImage?.map((image, index) => (
// 									<Box key={index} position="relative">
// 										<img
// 											src={image.preview || image.url}
// 											alt={`Menu ${index}`}
// 											style={{ width: 100, height: 100, objectFit: 'cover' }}
// 										/>
// 										<IconButton
// 											size="small"
// 											sx={{ position: 'absolute', top: 0, right: 0 }}
// 											onClick={() => handleRemoveImage(index)}
// 										>
// 											<CloseIcon />
// 										</IconButton>
// 									</Box>
// 								))}
// 							</Box>
// 							<input
// 								type="file"
// 								accept="image/*"
// 								multiple
// 								onChange={handleImageChange}
// 								style={{ display: 'none' }}
// 								id="menu-image-upload"
// 							/>
// 							<label htmlFor="menu-image-upload">
// 								<Button
// 									variant="outlined"
// 									component="span"
// 									sx={{
// 										'&:hover': {
// 											backgroundColor: 'primary.main',
// 											color: 'white',
// 										},
// 									}}
// 								>
// 									Upload Images
// 								</Button>
// 							</label>
// 						</Box>
// 					</Grid>
// 					<Grid item xs={12}>
// 						<Typography variant="subtitle2" gutterBottom>
// 							Description
// 						</Typography>
// 						<TextField
// 							fullWidth
// 							multiline
// 							rows={4}
// 							size="small"
// 							placeholder="Enter menu description"
// 							name="description"
// 							value={formData.description}
// 							onChange={handleChange}
// 							sx={{ backgroundColor: 'white' }}
// 						/>
// 					</Grid>
// 					<Grid item xs={12}>
// 						<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
// 							<Button variant="contained" type="submit" disabled={!validateForm()}>
// 								{menu ? 'Update Menu' : 'Create Menu'}
// 							</Button>
// 						</Box>
// 					</Grid>
// 				</Grid>
// 			</form>
// 		</Box>
// 	);
// };

// export default MenuForm;
import React, { useCallback, useEffect, useState } from 'react';
import {
	TextField,
	Button,
	Grid,
	Typography,
	Box,
	IconButton,
	MenuItem,
	FormControl,
	InputLabel,
	Select,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { getAllEvent } from '../../../services/api/Event';
import MenuSection from './MenuSection';
import { MennuTypeQuotation } from '../../../services/api/quotation';

// interface MenuItemType {
// 	menuType: any;
// 	numberOfPersons: number;
// 	menuItems: {
// 		Items: any;
// 	};
// }

interface FormData {
	_id: string;
	name: string;
	description: string;
	status: number;
	complementary: { item: string; quantity: number }[];
	price: number;
	menuTypes: any[];
	menuImage?: Array<{ file?: File; preview: string; url?: string }>;
	slug?: string;
	eventType: string;
}

interface MenuFormProps {
	menu?: any;
	onSubmit: (data: FormData) => void | Promise<void>;
	// availableMenuTypes?: string[];
}

const MenuForm: React.FC<MenuFormProps> = ({
	menu,
	onSubmit,
	// availableMenuTypes = ['Lunch', 'Dinner', 'Breakfast'],
}) => {
	const [menuTypes, setMenuTypes] = useState<string[]>([]);
	console.log(menuTypes, 'menutypes>>>>>>>>>>>>');

	const [eventTypes, setEventTypes] = useState<{ _id: string; eventType: string }[]>([]);
	const [selectedQuotation, setSelectedQuotation] = useState<any>();
	console.log(menu, 'menu');
	const [formData, setFormData] = useState<FormData>({
		_id: menu?._id || '',
		name: menu?.name || '',
		description: menu?.description || '',
		status: menu?.status || 0,
		complementary: menu?.complementary || [{ item: '', quantity: 1 }],
		price: menu?.price || 0,
		eventType: menu?.eventType?._id || '',
		menuTypes: menu?.menuTypes?.length
			? menu.menuTypes.map((item: any) => ({
					menuType: item?.menuType || '',
					numberOfPersons: item.numberOfPersons || 1,
					menuItems: item.menuItems,
				}))
			: [],
		menuImage: menu?.menuImage?.map((img: string) => ({ url: img })) || [],
		slug: menu?.slug || '',
	});
	console.log(formData, 'formData');

	const fetchAllCategories = async () => {
		try {
			const response = await MennuTypeQuotation(selectedQuotation);
			if (response.success) {
				setMenuTypes(response?.data?.menuTypeNames || []);
			}
		} catch (err) {
			console.error('Error fetching categories:', err);
			setMenuTypes([]);
		}
	};

	useEffect(() => {
		if (selectedQuotation) {
			setSelectedQuotation(menu?.eventType?._id);
			fetchAllCategories();
		}
	}, [selectedQuotation]);

	useEffect(() => {
		// return () =>
		formData.menuImage?.forEach((image) => {
			if (image.preview) URL.revokeObjectURL(image.preview);
		});
	}, []);

	const generateSlug = (name: string) =>
		name
			.toLowerCase()
			.replace(/\s+/g, '-')
			.replace(/[^\w-]+/g, '')
			.replace(/--+/g, '-')
			.replace(/^-/, '')
			.replace(/-$/, '');

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: name === 'price' ? parseFloat(value) || 0 : value,
		}));
	};

	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
			slug: generateSlug(value),
		}));
	};

	const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const files = e.target.files;
		if (files) {
			const newImages = Array.from(files).map((file) => ({
				file,
				preview: URL.createObjectURL(file),
			}));
			setFormData((prev) => ({
				...prev,
				menuImage: [...(prev.menuImage || []), ...newImages],
			}));
		}
	};

	const handleRemoveImage = (index: number) => {
		const updatedImages = [...(formData.menuImage || [])];
		if (updatedImages[index].preview) {
			URL.revokeObjectURL(updatedImages[index].preview);
		}
		updatedImages.splice(index, 1);
		setFormData((prev) => ({ ...prev, menuImage: updatedImages }));
	};

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (!validateForm()) {
			console.error('Form validation failed');
			return;
		}
		onSubmit(formData);
	};

	const validateForm = (): boolean =>
		!!formData.name &&
		formData.price >= 0 &&
		formData.menuTypes.length > 0 &&
		formData.menuTypes.every(
			(item) =>
				!!item.menuType && item.menuItems.Items.length > 0 && item.numberOfPersons >= 1
		) &&
		formData.complementary.every((item) => !!item.item && item.quantity >= 1);

	const handleAddMenuItem = () => {
		setFormData((prev: any) => ({
			...prev,
			menuTypes: [
				...prev.menuTypes,
				{
					menuType: menu
						? menuTypes.flatMap((item: any) => item?.menuType)
						: menuTypes[0],
					numberOfPersons: 1,
					menuItems: { Items: [] },
				},
			],
		}));
	};

	const handleMenuItemChange = (index: number, updatedItem: any) => {
		const updated = [...formData.menuTypes];
		updated[index] = updatedItem;
		setFormData((prev) => ({ ...prev, menuTypes: updated }));
	};

	const handleRemoveMenuItem = (index: number) => {
		const updated = [...formData.menuTypes];
		updated.splice(index, 1);
		setFormData((prev) => ({ ...prev, menuTypes: updated }));
	};

	const handleComplementaryItemChange = (
		index: number,
		field: 'item' | 'quantity',
		value: string | number
	) => {
		const updatedItems = [...formData.complementary];
		updatedItems[index][field] = value as never;
		setFormData((prev) => ({ ...prev, complementary: updatedItems }));
	};

	const handleAddComplementaryItem = () => {
		setFormData((prev) => ({
			...prev,
			complementary: [...prev.complementary, { item: '', quantity: 1 }],
		}));
	};

	const handleRemoveComplementaryItem = (index: number) => {
		const updatedItems = [...formData.complementary];
		updatedItems.splice(index, 1);
		setFormData((prev) => ({ ...prev, complementary: updatedItems }));
	};

	const loadEventTypes = useCallback(async () => {
		try {
			const response = await getAllEvent();
			const data = response?.data.eventTypes;
			setEventTypes(data);
			console.log(selectedQuotation, 'selectedQuotation');

			console.log(data, 'data');
			if (menu) {
				const menuTypefilters = data.filter(
					(item: any) => item?._id === menu?.eventType?._id
				);
				setMenuTypes(menuTypefilters);
			}
		} catch (error) {
			console.error('Failed to load event types:', error);
		}
	}, []);

	useEffect(() => {
		loadEventTypes();
	}, [loadEventTypes, menu]);

	return (
		<Box component="div" sx={{ padding: 2 }}>
			<Typography variant="subtitle1" gutterBottom sx={{ marginBottom: 3 }}>
				{menu ? 'Update the menu details' : 'Fill in the details to add a new Menu'}
			</Typography>
			<form onSubmit={handleSubmit} id="menu-form">
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" gutterBottom>
							Menu Name *
						</Typography>
						<TextField
							fullWidth
							size="small"
							placeholder="e.g., Budget buffet menu"
							name="name"
							value={formData.name}
							onChange={handleNameChange}
							required
							sx={{ backgroundColor: 'white' }}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" gutterBottom>
							Slug *
						</Typography>
						<TextField
							fullWidth
							size="small"
							placeholder="e.g., budget-buffet-menu"
							name="slug"
							value={formData.slug}
							onChange={handleChange}
							required
							sx={{ backgroundColor: 'white' }}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" gutterBottom>
							Price *
						</Typography>
						<TextField
							fullWidth
							size="small"
							placeholder="e.g., 399000"
							name="price"
							type="number"
							value={formData.price}
							onChange={handleChange}
							inputProps={{ step: '0.01' }}
							required
							sx={{ backgroundColor: 'white' }}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Typography variant="subtitle2" gutterBottom>
							Event Type *
						</Typography>
						<FormControl size="small" fullWidth>
							<InputLabel>Event Type</InputLabel>
							<Select
								value={formData.eventType}
								onChange={(e) => {
									setFormData({
										...formData,
										eventType: e.target.value,
									});
									setSelectedQuotation(e?.target?.value);
								}}
								label="Event Type"
								required
							>
								{eventTypes.map((type) => (
									<MenuItem key={type._id} value={type._id}>
										{type.eventType}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>

					<Grid item xs={12}>
						<Box mb={4}>
							<Typography
								variant="subtitle1"
								color="primary"
								gutterBottom
								sx={{ fontWeight: 'bold' }}
							>
								Menu Items *
							</Typography>

							{formData?.menuTypes?.map((menuItem, index) => (
								<MenuSection
									key={index}
									menuItem={menuItem}
									onChange={(updatedItem) =>
										handleMenuItemChange(index, updatedItem)
									}
									onRemove={() => handleRemoveMenuItem(index)}
									availableMenuTypes={
										menu
											? menuTypes.flatMap((item: any) => item?.menuType)
											: menuTypes
									}
								/>
							))}
							<Button
								variant="outlined"
								startIcon={<AddIcon />}
								onClick={handleAddMenuItem}
								sx={{
									mt: 2,
									'&:hover': {
										backgroundColor: 'primary.main',
										color: 'white',
									},
								}}
							>
								Add Another Menu Type
							</Button>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Box mb={4} mt={2}>
							<Typography
								variant="subtitle1"
								color="primary"
								gutterBottom
								sx={{ fontWeight: 'bold' }}
							>
								Complementary Items
							</Typography>
							{formData.complementary.map((item, index) => (
								<Box key={index} display="flex" alignItems="center" gap={2} mb={2}>
									<TextField
										label="Item Name"
										value={item.item}
										onChange={(e) =>
											handleComplementaryItemChange(
												index,
												'item',
												e.target.value
											)
										}
										size="small"
										fullWidth
									/>
									<TextField
										label="Quantity"
										type="number"
										value={item.quantity}
										onChange={(e) =>
											handleComplementaryItemChange(
												index,
												'quantity',
												parseInt(e.target.value)
											)
										}
										size="small"
									/>
									{formData.complementary.length > 1 && (
										<IconButton
											onClick={() => handleRemoveComplementaryItem(index)}
										>
											<CloseIcon />
										</IconButton>
									)}
								</Box>
							))}
							<Button
								variant="outlined"
								startIcon={<AddIcon />}
								onClick={handleAddComplementaryItem}
							>
								Add Complementary Item
							</Button>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Box mb={4}>
							<Typography
								variant="subtitle1"
								color="primary"
								gutterBottom
								sx={{ fontWeight: 'bold' }}
							>
								Menu Images
							</Typography>
							<Typography variant="caption">Maximum 10 Images</Typography> <br />
							<Box display="flex" flexWrap="wrap" gap={1} mt={2}>
								{formData.menuImage?.map((image, index) => (
									<Box key={index} position="relative">
										<img
											src={image.preview || image.url}
											alt={`Menu ${index}`}
											style={{ width: 100, height: 100, objectFit: 'cover' }}
										/>
										<IconButton
											size="small"
											sx={{ position: 'absolute', top: 0, right: 0 }}
											onClick={() => handleRemoveImage(index)}
										>
											<CloseIcon />
										</IconButton>
									</Box>
								))}
							</Box>
							<input
								type="file"
								accept="image/*"
								multiple
								onChange={handleImageChange}
								style={{ display: 'none' }}
								id="menu-image-upload"
							/>
							<label htmlFor="menu-image-upload">
								<Button
									variant="outlined"
									component="span"
									sx={{
										'&:hover': {
											backgroundColor: 'primary.main',
											color: 'white',
										},
									}}
								>
									Upload Images
								</Button>
							</label>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="subtitle2" gutterBottom>
							Description
						</Typography>
						<TextField
							fullWidth
							multiline
							rows={4}
							size="small"
							placeholder="Enter menu description"
							name="description"
							value={formData.description}
							onChange={handleChange}
							sx={{ backgroundColor: 'white' }}
						/>
					</Grid>
					{/* <Grid item xs={12}>
						<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
							<Button variant="contained" type="submit" disabled={!validateForm()}>
								{menu ? 'Update Menu' : 'Create Menu'}
							</Button>
						</Box>
					</Grid> */}
				</Grid>
			</form>
		</Box>
	);
};

export default MenuForm;
